export default __webpack_public_path__ + "static/media/percent-select.dc8d16e8.svg";